import React from "react";

import { Alert } from "~/components/alert";

export function CannotRemoveRuleAlert() {
	return (
		<Alert variant="warning">
			<strong className="font-semibold">You cannot remove this silencing rule</strong> either because it was set by an
			external application or because you are not authorized to do so.
		</Alert>
	);
}
